// Site-wide constants CommonJS so it can be required from Node (gatsby-*.js) as
// well as imported in src/.

// Official social profiles. Used by the footer, the Organization JSON-LD `sameAs`
// list, and the twitter:site / twitter:creator meta tags.
const socialProfiles = {
  linkedin: "https://www.linkedin.com/company/wing-spans/",
  twitter: "https://twitter.com/Wing_spans",
  facebook: "https://www.facebook.com/YourWingspans",
}

const twitterHandle = "@Wing_spans"

// Template for a social share image
const shareImage = {
  path: "/assets/images/social-share-image.png",
  width: 1200,
  height: 630,
}

const homePageThumbnail = {
  path: "/assets/images/home-page-thumbnail.png",
  width: 2400,
  height: 1260,
  alt: "Wingspans: two women laughing together",
}

// public-facing Cosmic basic pages
const indexableBasicPageSlugs = ["privacy-policy", "terms-of-use"]

exports.indexableBasicPageSlugs = indexableBasicPageSlugs
exports.socialProfiles = socialProfiles
exports.twitterHandle = twitterHandle
exports.shareImage = shareImage
exports.homePageThumbnail = homePageThumbnail
